var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: {
        value: _vm.open,
        persistent: "",
        "max-width": "350",
        "content-class": "task-item-dialog"
      }
    },
    [
      _c(
        "v-card",
        { staticClass: "home-form-container", attrs: { color: "#f0f0ef" } },
        [
          _vm.editedItem !== null
            ? _c(
                "v-card-text",
                {
                  staticClass: "home-form-container",
                  staticStyle: { "text-align": "left", padding: "4px 0 0 0" }
                },
                [
                  _c("input-field", {
                    attrs: {
                      label: _vm.$tc("Label"),
                      "variable-name": "title",
                      "input-type": "text",
                      size: "100",
                      required: true
                    },
                    model: {
                      value: _vm.editedItem.label,
                      callback: function($$v) {
                        _vm.$set(_vm.editedItem, "label", $$v)
                      },
                      expression: "editedItem.label"
                    }
                  }),
                  _vm._v(" "),
                  _c("input-field", {
                    attrs: {
                      label: _vm.$tc("Index"),
                      "variable-name": "title",
                      "input-type": "number",
                      size: "100",
                      required: true
                    },
                    model: {
                      value: _vm.editedItem.index,
                      callback: function($$v) {
                        _vm.$set(_vm.editedItem, "index", $$v)
                      },
                      expression: "editedItem.index"
                    }
                  }),
                  _vm._v(" "),
                  _c("v-checkbox", {
                    staticClass: "mt-1 ml-4",
                    attrs: { label: _vm.$tc("Required"), color: "accent" },
                    model: {
                      value: _vm.editedItem.required,
                      callback: function($$v) {
                        _vm.$set(_vm.editedItem, "required", $$v)
                      },
                      expression: "editedItem.required"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _vm._v(" "),
              _c("management-button", {
                attrs: { type: "cancel", label: _vm.$t("Cancel") },
                on: { buttonClick: _vm.close }
              }),
              _vm._v(" "),
              _c("management-button", {
                attrs: {
                  type: "execute",
                  label: _vm.editing ? _vm.$t("ApplyChanges") : _vm.$t("Add"),
                  disabled: _vm.requiredAreFilled
                },
                on: { buttonClick: _vm.applyChanges }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-00a2b13e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-00a2b13e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Forms/_SpecialTabs/Activities/TaskTypes/Checklists/ChecklistItemEdition.vue
// module id = null
// module chunks = 